import { Component, OnInit } from '@angular/core';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';

@Component({
    selector: 'app-image-link-list',
    templateUrl: './image-link-list.component.html',
    styleUrls: ['./image-link-list.component.scss']
})
export class ImageLinkListComponent implements OnInit {
  content:any;
  constructor(private readonly registerContent:SignUpContentServiceService){

  }
  ngOnInit(){
    this.registerContent.content$.subscribe((res:any)=>{
      this.content = res;
    })
  }
}